import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
import { useCountdown } from '../utils/useCountdown';
export function UrgencySection() {
  const t = useCountdown();
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full bg-[#B91C1C] px-6 py-16" data-id="element-304">
      <div className="max-w-xl mx-auto flex flex-col items-center text-center" data-id="element-305">
        <h2 className="text-[28px] font-bold text-white mb-4 leading-tight" data-id="element-306">
          ⚡ OFERTA DE LANZAMIENTO
        </h2>
        <p className="text-white/90 text-[16px] leading-relaxed mb-8" data-id="element-307">
          Este precio es de lanzamiento. Cuando alcancemos las primeras 200
          compradoras, el precio sube.
        </p>

        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-308">
          <div className="flex flex-col items-center" data-id="element-309">
            <span className="text-white font-bold text-[40px] leading-none" data-id="element-310">
              {pad(t.hours)}
            </span>
            <span className="text-white/70 text-[12px] uppercase font-bold mt-1" data-id="element-311">
              Horas
            </span>
          </div>
          <span className="text-white/50 text-[32px] font-bold -mt-5" data-id="element-312">:</span>
          <div className="flex flex-col items-center" data-id="element-313">
            <span className="text-white font-bold text-[40px] leading-none" data-id="element-314">
              {pad(t.minutes)}
            </span>
            <span className="text-white/70 text-[12px] uppercase font-bold mt-1" data-id="element-315">
              Minutos
            </span>
          </div>
          <span className="text-white/50 text-[32px] font-bold -mt-5" data-id="element-316">:</span>
          <div className="flex flex-col items-center" data-id="element-317">
            <span className="text-white font-bold text-[40px] leading-none" data-id="element-318">
              {pad(t.seconds)}
            </span>
            <span className="text-white/70 text-[12px] uppercase font-bold mt-1" data-id="element-319">
              Segundos
            </span>
          </div>
        </div>

        <p className="text-white/60 text-[18px] font-bold line-through mb-1" data-id="element-320">
          Valor real: $89.000
        </p>
        <p className="text-white text-[48px] font-bold leading-none mb-4" data-id="element-321">
          Hoy: $19.990
        </p>
        <p className="text-white/90 text-[15px] leading-relaxed mb-8" data-id="element-322">
          Menos que 1 consulta privada. Menos que 1 caja de óvulos + 1 turno
          médico.
        </p>

        <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: 'Urgency CTA',
        value: 19990,
        currency: 'ARS'
      })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[16px] rounded-xl py-4 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-323">
          🔓 QUIERO EL MÉTODO pH-ZERO
        </a>
      </div>
    </section>;
}